import React, { useState, useEffect } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";

import { getAllCriteria } from "../../api/apiCriteria.js";
import { grayColor } from "../../assets/jss/material-dashboard-react";
import InputNumbersForm from "../../components/Form/InputNumbersForm";
import MatrixForm from "../../components/Form/MatrixForm";
import AlternativesNamesForm from "../../components/Form/AlternativesNamesForm";

const styles = (theme) => ({
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
  cardTitle: {
    color: grayColor[2],
    marginTop: "0px",
    minHeight: "auto",
    fontSize: "12px",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "0px",
    textDecoration: "none",
    paddingBottom: "20px",
  },
  cardCategory: {
    color: grayColor[0],
    margin: "0",
    fontSize: "16px",
    marginTop: "0",
    paddingTop: "10px",
    marginBottom: "0",
  },
  description: {
    marginTop: "2px",
    marginBottom: "0",
    textAlign: "justify",
  },
  rowReverseMd: {
    [theme.breakpoints.up("md")]: {
      display: "flex",
      flexDirection: "row-reverse",
    },
  },
});

const useStyles = makeStyles(styles);

export default function WizardWelcomeScreen() {
  const classes = useStyles();

  const [alternativesNum, setAlternativesNum] = useState("");
  const [alternativesNames, setAlternativeNames] = useState([]);
  const [criteriaNum, setCriteriaNum] = useState("");

  // screen: 0: InputNumbersForm, 1: AlternativesNames, 2: MatrixForm
  const [screen, setScreen] = useState(0);
  const [criteria, setCriteria] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const retData = await getAllCriteria(true);
        setCriteria(retData);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  const onNext = () => {
    setScreen((prev) => prev + 1);
  };

  const onBack = () => {
    setScreen((prev) => prev - 1);
  };
  return (
    <div>
      <GridContainer className={classes.rowReverseMd} justify="center">
        <GridItem xs={12} sm={screen !== 2 ? 6 : 12} md={screen !== 2 ? 6 : 12}>
          {screen === 0 && (
            <InputNumbersForm
              alternativesNum={alternativesNum}
              criteriaNum={criteriaNum}
              setAlternativesNum={setAlternativesNum}
              setCriteriaNum={setCriteriaNum}
              onNext={onNext}
            />
          )}
          {screen === 1 && (
            <AlternativesNamesForm
              alternativesNum={alternativesNum}
              onNext={onNext}
              onBack={onBack}
              alternativesNames={alternativesNames}
              changeAlternativeNames={setAlternativeNames}
            ></AlternativesNamesForm>
          )}
          {screen === 2 && (
            <MatrixForm
              alternativesNum={alternativesNum}
              alternativesNames={alternativesNames}
              criteriaNum={criteriaNum}
              criteria={criteria}
              onNext={onNext}
              onBack={onBack}
            />
          )}
        </GridItem>
      </GridContainer>
    </div>
  );
}

